// Client-safe subscription constants and helpers
// This file can be imported in client components

// Feature IDs as constants for type safety
export const FEATURES = {
  // Core features
  TIMELINE: 'timeline',
  TIMELINE_INSIGHTS: 'timeline_insights',
  SOCIAL_CIRCLE: 'social_circle',
  SOCIAL_ANALYTICS: 'social_analytics',
  PROFILE_ANALYSIS: 'profile_analysis',
  ARCHIVE_IMPORT: 'archive_import',
  TWEET_SEARCH: 'tweet_search',
  DIGEST_DAILY: 'digest_daily',
  // Premium features
  USER_ANALYSIS_DATE_RANGE: 'user_analysis_date_range',
  API_ACCESS: 'api_access',
  PRIORITY_SUPPORT: 'priority_support',
  AI_MODEL_SELECTION: 'ai_model_selection',
  // Debug features
  DEBUG: 'debug',
} as const;

export type FeatureId = (typeof FEATURES)[keyof typeof FEATURES];

// Subscription tier IDs
export const TIERS = {
  FREE: 'free',
  PRO: 'pro',
  BUSINESS: 'business',
} as const;

export type TierId = (typeof TIERS)[keyof typeof TIERS];
